import _axios from '../../apiClient'

export function getInstalacion(payload) {
    return _axios.get(`/api/Instalacion/Get`,
    { 
        params: { url: payload } 
    },
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}



export function getUsuarioLogeado() {
  return _axios.get(`/api/Usuario/CurrentUser`,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function autenticarUsuario(payload) {
  return _axios.post(`/api/Usuario/Autenticar`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function restablecerContrasenia(payload) {
  return _axios.post(`/api/Usuario/RestablecerContrasenia`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function olvidoContrasenia(payload) {
  return _axios.post(`/api/Usuario/OlvidoContrasenia`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function validarCodigo(payload) {
  return _axios.post(`/api/Usuario/ValidarCodigo`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function logOutUsuario() {
  return _axios.post(`/api/Usuario/logOutUsuario`,
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}


export function getImagenLogin(payload) {
  return _axios.get(`/api/Instalacion/GetImagenLogin`,
  { 
    params: { idInstalacion: payload } 
  },
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setMontoCompraMinima(payload) {
  return _axios.get(`/api/Instalacion/SetMontoCompraMinima`,
  { 
    params: { monto: payload.monto, idInstalacion: payload.idInstalacion } 
  },
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setConfiguracionDelivery(payload) {
  return _axios.get(`/api/Instalacion/SetConfiguracionDelivery`,
  { 
    params: { cobroDelivery: payload.cobroDelivery, monto: payload.monto, idInstalacion: payload.idInstalacion } 
  },
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setNuevaClavePicking(payload) {
  
  return _axios.put(`/api/Instalacion/AdminNewPasword`,

  payload,
  
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}

export function setGetClavePicking(payload) {
  
  return _axios.get(`/api/Instalacion/AdminPassword`,

  payload,
  
  {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}